import { DEFAULT_PAGE_SIZE } from '@/constants';
import { usePaginatedCrudModel } from '@/models/shared/usePaginatedCrudModel';
import {
  createSegment,
  deleteSegment,
  fetchSegment,
  reactivateSegment,
  updateSegment,
} from '@/services/segment/segmentService';
import type {
  Segment,
  SegmentListParams,
  SegmentListResult,
  SegmentPayload,
} from '@/types/segment';
import { useCallback } from 'react';

const useSegmentModel = () => {
  const { items, loading, pagination, loadItems, create, update, remove } =
    usePaginatedCrudModel<
      Segment,
      SegmentListParams,
      SegmentPayload,
      SegmentPayload,
      SegmentListResult
    >({
      defaultPageSize: DEFAULT_PAGE_SIZE,
      initialQuery: {},
      loadList: fetchSegment,
      buildQuery: (params, lastQuery, paginationState) => ({
        page: params.page ?? paginationState.current,
        size:
          params.size ??
          params.page_size ??
          params.pageSize ??
          paginationState.pageSize,
        name: 'name' in params ? params.name : lastQuery.name,
        status: 'status' in params ? params.status : lastQuery.status,
      }),
      createItem: createSegment,
      updateItem: updateSegment,
      deleteItem: deleteSegment,
    });

  const reactivate = useCallback(async (id: number) => {
    return reactivateSegment(id);
  }, []);

  return {
    items,
    loading,
    pagination,
    loadSegments: loadItems,
    create,
    update,
    remove,
    reactivate,
  };
};

export default useSegmentModel;
